import { useMutation } from 'react-apollo';

import {
  teamMemberLogin as teamMemberLoginMutation,
  teamMemberPasswordResetRequest as teamMemberPasswordResetRequestMutation,
} from '../../../graphql/mutations/team-members';

const useTeamLogin = () => {
  const [teamMemberLogin] = useMutation(teamMemberLoginMutation);
  const [teamMemberPasswordResetRequest] = useMutation(
    teamMemberPasswordResetRequestMutation,
  );

  const onTeamLogin = async ({ emailAddress, teamIdentifier, password }) => {
    const result = await teamMemberLogin({
      variables: {
        input: {
          email_address: emailAddress,
          team_identifier: teamIdentifier,
          password,
        },
      },
    });

    return result;
  };

  const onTeamMemberPasswordResetRequest = async ({
    emailAddress,
    teamIdentifier,
  }) =>
    teamMemberPasswordResetRequest({
      variables: {
        input: {
          email_address: emailAddress,
          team_identifier: teamIdentifier,
        },
      },
    });

  return {
    onTeamLogin,
    onTeamMemberPasswordResetRequest,
  };
};

export default useTeamLogin;
